module.exports = __webpack_public_path__ + "img/cloudhealth.b8a699ab.png";